module.exports = __webpack_public_path__ + "img/styles_background_desktop.e9e4d98.webp";